import ContentfulImageRenderer from 'contentful/image_renderer';
import resolvedData from 'contentful/ResolveContentfulResponse';
import trimString from 'utils/trimString';

const PostList = ({ posts, showImages }) => {
  const parsedPosts = resolvedData(posts);
  return (
    !!parsedPosts.length && (
      <ul className="post-list fl fl-col m-0">
        {parsedPosts.map(
          ({ sys: { id }, fields: { title, slug, heroImage } }) => (
            <li className="post-list__post pb-16" key={id}>
              <a
                href={`/blogs/${slug}`}
                className="post-list__link tc-main fs-14 fw-600 fl">
                {showImages && !!Object.keys(heroImage || {}).length && (
                  <div className="post-list__image">
                    <ContentfulImageRenderer image={heroImage} />
                  </div>
                )}
                <span>{trimString(title, 14)}</span>
              </a>
            </li>
          ),
        )}
      </ul>
    )
  );
};

export default PostList;
